import React from 'react';
import { useTranslation } from 'react-i18next';
import FlyoutMenu from '../FlyoutMenu/FlyoutMenu';
import { Icon } from '../Icon/Icon';
import { isSupportedLanguage } from '../../shared/supported-languages';
import CONFIG from '../../config/config';

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className = "" }) => {
  const { i18n } = useTranslation();

  const languages = CONFIG.SUPPORTED_LANGUAGES.map(l => {
    return {
      code: l.code,
      name: '',
      onClick: () => i18n.changeLanguage(l.code),
      icon: <Icon url={l.icon} cssStyles="w-5 rounded h-3"/>,
    }
  });

  const languageMenuItems = languages.map((lang) => ({
    headline: '',
    text: '',
    onClick: () => i18n.changeLanguage(lang.code),
    isDisabled: false,
    icon: lang.icon,
  }));

  const currentLanguageIcon = isSupportedLanguage(i18n.language)
    ? languages.filter(l => l.code === i18n.language)[0]?.icon
    : languages.filter(l => l.code === CONFIG.DEFAULT_LANGUAGE.code)[0]?.icon;

  return (
    <span className={`flex justify-center ${className}`}>
      <FlyoutMenu
        menuItems={languageMenuItems}
        trigger={currentLanguageIcon}
        mobileTrigger={currentLanguageIcon}
      />
    </span>
  );
};

export default LanguageSwitcher;

